import { createStore } from "vuex";
// import axios from "axios";
import { getRouteBase } from "../services/tenant.js";
import authModule from "./modules/auth/index.js";
import managerModule from "./modules/manager/index.js";
import reportsModule from "./modules/reports/index.js";

function baseURL() {
  return getRouteBase();
}

const store = createStore({
  modules: {
    auth: authModule,
    manger: managerModule,
    report: reportsModule,
  },
  state() {
    return {
      lang: "en",
      homePermission: "A",
      phonePermission: "F",
      sipPermission: "T",
      smsPermission: "P",
      chatPermission: "V",
      callForwardPermission: "L",
      agentsReportsPermission: "B",
      queueDashboardPermission: "G",
      agentStatusPermission: "H",
      skillChoosePermission: "C",
      editAdminPermission: "M",
      setCallerIDPermission: "N",
      summaryStatsPermission: "R",
      callReasonPermission: "Q",
      ticketsPermission: "S",
      callerInfoPermission: "E",
      transferPermission: "U",
      omniChannelPermission: "W",
      ManageOmniChannelPermission: "X",
      assistantBotPermission: "Y",
      slaAlertingPermission: "Z",
      campaignsPermission: "AD",
      // Shares the reports permission until the backend exposes a dedicated
      // one for the AI reports (Voice Agent CDR, AI Chat Transcript).
      aiReportsPermission: "I",
      isPhoneDrawn: false,
      status: 1,
      showProgress: false,
      showFooter: true,
      progressMessage: "",
      showMessage: false,
      statusMessage: "",
      periods: [],
      statusType: null,
      sessionLogOff: false,
      phoneSocket: null,
      agentPhone: null,
      dahsboardInterval: null,
      lastCallsInterval: null,
      summaryInterval: null,
      mainSummaryInterval: null,
      mainTrafficInterval: null,
      adminDashboardInterval: null,
      supportedLangs: ["ar", "en"],
      logos: null,
      acwReason: "reason",
      acwCRM: "crm",
      acwTicketing: "ticketing",
      navigationsMenu: [
        {
          title: "Home",
          icon: "mdi-chart-box-outline",
          path: baseURL() + "/Home",
          permission: "A",
        },
        {
          title: "Agent_Reports",
          icon: "mdi-file-document",
          path: baseURL() + "/agents-calls-report",
          permission: "B",
          hide: true,
          children: [
            {
              title: "Agent_Calls_Report",
              path: baseURL() + "/Reports/AgentCalls",
              icon: "mdi-file-document",
            },
            {
              title: "Agent_Status_Report",
              path: baseURL() + "/Reports/AgentStatus",
              icon: "mdi-file-document",
            },
          ],
        },
        {
          title: "title",
          icon: "mdi-file-document",
          path: baseURL() + "/Reports",
          permission: "I",
        },
        {
          title: "settings",
          icon: "mdi-cog-outline",
          path: baseURL() + "/Settings",
          permission: "I",
        },
        {
          title: "campaigns-management",
          icon: "mdi-bullhorn-outline",
          path: baseURL() + "/Campaigns",
          permission: "AD",
        },
        {
          title: "ivr-management",
          icon: "mdi-sitemap",
          path: baseURL() + "/IVR",
          permission: "AD",
        },
        {
          title: "social-media",
          icon: "mdi-email-outline",
          path: baseURL() + "/social-media",
          permission: "W",
        },
        {
          title: "chat",
          icon: "mdi-account-switch",
          path: baseURL() + "/Chat",
          permission: "A",
        },
        {
          title: "ai-assistant",
          icon: "mdi-assistant",
          path: baseURL() + "/ai-assistant",
          permission: "AD",
        },
        {
          title: "Domains",
          icon: "mdi-domain",
          path: baseURL() + "/Domains",
          permission: "SA",
        },
        {
          title: "Procesors",
          icon: "mdi-buffer",
          path: baseURL() + "/ProcessorsList",
          permission: "O",
        },
      ],
      colors: {
        wait: "#40B5AD",
        incoming: "#00FFFF",
        outgoing: "#4169E1",
        offline: "#DC143C",
        busy: "#FF5F15",
        rest: "#DFFF00",
        idle: "#C1E1C1",
        talking: "#98FB98",
      },
      sentiment: "neutral",
      isCollapsed: false,
      webRTCNeedsCheck: false, // Flag for WebRTC health check synchronization
    };
  },
  getters: {
    // getPages(state) {
    //   return JSON.parse(JSON.stringify(state.pages));
    // },
    // getSections(state) {
    //   return JSON.parse(JSON.stringify(state.sections));
    // },
    navigationsMenu(state) {
      return JSON.parse(JSON.stringify(state.navigationsMenu));
    },
    supportedLangs(state) {
      return JSON.parse(JSON.stringify(state.supportedLangs));
    },
    homePermission(state) {
      return state.homePermission;
    },
    isPhoneDrawn(state) {
      return state.isPhoneDrawn;
    },
    phonePermission(state) {
      return state.phonePermission;
    },
    aiReportsPermission(state) {
      return state.aiReportsPermission;
    },
    sipPermission(state) {
      return state.sipPermission;
    },
    smsPermission(state) {
      return state.smsPermission;
    },
    callForwardPermission(state) {
      return state.callForwardPermission;
    },
    agentsReportsPermission(state) {
      return state.agentsReportsPermission;
    },
    chatPermission(state) {
      return state.chatPermission;
    },
    ManageOmniChannelPermission(state) {
      return state.ManageOmniChannelPermission;
    },
    phoneSocket(state) {
      if (state.phoneSocket) {
        return JSON.parse(JSON.stringify(state.phoneSocket));
      }
      return null;
    },
    agentPhone(state) {
      if (state.agentPhone) {
        return JSON.parse(JSON.stringify(state.agentPhone));
      }
      return null;
    },
    dahsboardInterval(state) {
      return state.dahsboardInterval;
    },
    lastCallsInterval(state) {
      return state.lastCallsInterval;
    },
    summaryInterval(state) {
      return state.summaryInterval;
    },
    queueDashboardPermission(state) {
      return state.queueDashboardPermission;
    },
    agentStatusPermission(state) {
      return state.agentStatusPermission;
    },
    skillChoosePermission(state) {
      return state.skillChoosePermission;
    },
    editAdminPermission(state) {
      return state.editAdminPermission;
    },
    setCallerIDPermission(state) {
      return state.setCallerIDPermission;
    },
    summaryStatsPermission(state) {
      return state.summaryStatsPermission;
    },
    callReasonPermission(state) {
      return state.callReasonPermission;
    },
    transferPermission(state) {
      return state.transferPermission;
    },
    ticketsPermission(state) {
      return state.ticketsPermission;
    },
    callerInfoPermission(state) {
      return state.callerInfoPermission;
    },
    omniChannelPermission(state) {
      return state.omniChannelPermission;
    },
    assistantBotPermission(state) {
      return state.assistantBotPermission;
    },
    SLAAlertingPermission(state) {
      return state.slaAlertingPermission;
    },
    campaignsPermission(state) {
      return state.campaignsPermission;
    },
    showProgress(state) {
      return state.showProgress;
    },
    progressMessage(state) {
      return state.progressMessage;
    },
    showMessage(state) {
      return state.showMessage;
    },
    showFooter(state) {
      return state.showFooter;
    },
    statusMessage(state) {
      return state.statusMessage;
    },
    statusType(state) {
      return state.statusType;
    },
    sessionLogOff(state) {
      return state.sessionLogOff;
    },
    acwReason(state) {
      return state.acwReason;
    },
    acwCRM(state) {
      return state.acwCRM;
    },
    acwTicketing(state) {
      return state.acwTicketing;
    },
    periods(state) {
      return JSON.parse(JSON.stringify(state.periods));
    },
    logos(state) {
      return JSON.parse(JSON.stringify(state.logos));
    },
    currentLocal() {
      return "";
    },
    colors(state) {
      return JSON.parse(JSON.stringify(state.colors));
    },
    getbaseURL() {
      return getRouteBase();
    },
    lang(state) {
      return state.lang;
    },
    sentiment(state) {
      return state.sentiment;
    },
    isCollapsed(state) {
      return state.isCollapsed;
    },
    webRTCNeedsCheck(state) {
      return state.webRTCNeedsCheck;
    },
  },
  mutations: {
    updateProcessors(state, payload) {
      state.processers = payload;
    },
    setShowFooter(state, payload) {
      state.showFooter = payload;
    },
    setProgressStatus(state, payload) {
      state.showProgress = payload.show;
      state.progressMessage = payload.message;
    },
    SetMessageDialog(state, payload) {
      state.showMessage = payload.show;
      state.statusMessage = payload.message;
      state.statusType = payload.success;
    },
    setRestPeriods(state, payload) {
      state.periods = payload;
    },
    setIsPhoneDrawn(state, payload) {
      state.isPhoneDrawn = payload;
    },
    setLogos(state, payload) {
      state.logos = payload;
    },
    setSessionLogOff(state, payload) {
      // console.log("My set session ", payload);
      state.sessionLogOff = payload;
    },
    setWebPhone(state, payload) {
      state.phoneSocket = payload.socket;
      state.agentPhone = payload.phone;
    },
    setDashboardInterval(state, payload) {
      state.dahsboardInterval = payload;
    },
    setLastCallInterval(state, payload) {
      state.lastCallsInterval = payload;
    },
    setsummaryInterval(state, payload) {
      state.summaryInterval = payload;
    },
    setMainsummaryInterval(state, payload) {
      state.mainSummaryInterval = payload;
    },
    setMainTrafficInterval(state, payload) {
      state.mainTrafficInterval = payload;
    },
    setAdminDashboardInterval(state, payload) {
      state.adminDashboardInterval = payload;
    },
    setLang(state, payload) {
      if (payload) {
        state.lang = payload;
        localStorage.setItem("lang", payload);
      }
    },
    setSentiment(state, payload) {
      state.sentiment = payload;
    },
    setIsCollapsed(state, payload) {
      state.isCollapsed = payload;
    },
    setWebRTCNeedsCheck(state, payload) {
      state.webRTCNeedsCheck = payload;
    },
  },
  actions: {
    //GetRestPeriods
    async GetRestPeriods(context) {
      const response = await authModule.actions.middleware.get(
        "/GetRestPeriods",
        {
          headers: { request: "GetRestPeriods" },
        }
      );

      const responseData = await response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
        //   const error = new Error(responseData.message || "Failed to get users");
        //   throw error;
      }
      // console.log(responseData);
      if (responseData.success) {
        context.commit("setRestPeriods", responseData.result.periods);
      }

      return { success: responseData.success, message: responseData.message };
    },
    //SkillsDashboard
    async GetSkillsDashboard() {
      const response = await authModule.actions.middleware.get(
        "/SkillsDashboard",
        {
          headers: { request: "SkillsDashboard" },
        }
      );

      const responseData = await response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
        //   const error = new Error(responseData.message || "Failed to get users");
        //   throw error;
      }
      // console.log(responseData);

      return {
        success: responseData.success,
        message: responseData.message,
        queues: responseData.result.skills,
      };
    },
    //SkillsMonitor
    async GetSkillsMonitor(_, payload) {
      const response = await authModule.actions.middleware.get(
        "/SkillsMonitor",
        {
          params: {
            skills: payload.join(","),
          },
          headers: { request: "SkillsMonitor" },
        }
      );

      const responseData = await response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
        //   const error = new Error(responseData.message || "Failed to get users");
        //   throw error;
      }
      // console.log(responseData);

      return {
        success: responseData.success,
        message: responseData.message,
        result: responseData.result,
      };
    },

    async MonitorAction(context, payload) {
      const requestBody = {
        action: payload.action,
        channel: payload.channel,
        workStatus: payload.workstatus,
      };

      // Add agent parameter if provided (for whisper action)
      if (payload.agent) {
        requestBody.agent = payload.agent;
      }

      const response = await authModule.actions.middleware.post(
        "/MonitorAction",
        JSON.stringify(requestBody),
        {
          headers: { request: "MonitorAction" },
        }
      );

      const responseData = await response.data;
      if (response.status !== 200) {
        // console.log(responseData);
        return {
          success: responseData.success,
          message: responseData.message,
        };
      }

      // Store the agent and channel when whisper starts (action 2)
      if (payload.action === 2 && payload.agent && payload.channel && responseData.success) {
        context.commit('setWhisperedAgent', payload.agent);
        context.commit('setWhisperedChannel', payload.channel);
      }

      return { success: responseData.success, message: responseData.message };
    },
    async GetActiveCall(_, payload) {
      let caller = "";
      if (payload && payload != "") {
        caller = "?caller=" + payload;
      }
      const response = await authModule.actions.middleware.get(
        "/GetActiveCall" + caller,
        {
          headers: { request: "GetActiveCall" },
        }
      );

      const responseData = await response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
      }

      return {
        success: responseData.success,
        message: responseData.message,
        call: responseData.result.call,
      };
    },

    async HangupCall(_, payload) {
      const response = await authModule.actions.middleware.post(
        "/HangupCall",
        JSON.stringify({
          channel: payload,
        }),
        {
          headers: { request: "HangupCall" },
        }
      );

      const responseData = await response.data;
      if (response.status !== 200) {
        // console.log(responseData);
        return {
          success: responseData.success,
          message: responseData.message,
        };
      }
      return { success: responseData.success, message: responseData.message };
    },
    async TransferCall(_, payload) {
      console.log("Inside TransferCall Request: ", payload.skill);
      const response = await authModule.actions.middleware.post(
        "/TransferCall",
        JSON.stringify({
          channel: payload.channel,
          DestinationExten: payload.skill,
          Context: payload.context,
        }),
        {
          headers: { request: "TransferCall" },
        }
      );

      const responseData = await response.data;
      if (response.status !== 200) {
        // console.log(responseData);
        return {
          success: responseData.success,
          message: responseData.message,
        };
      }
      return { success: responseData.success, message: responseData.message };
    },
    async AddReasonsToCall(_, payload) {
      const response = await authModule.actions.middleware.post(
        "/AddReasonsToCall",
        JSON.stringify({
          ...payload,
        }),
        {
          headers: { request: "AddReasonsToCall" },
        }
      );

      const responseData = await response.data;
      if (response.status !== 200) {
        // console.log(responseData);
        return {
          success: responseData.success,
          message: responseData.message,
        };
      }
      return { success: responseData.success, message: responseData.message };
    },
    async UpdateReasonsToCall(_, payload) {
      const response = await authModule.actions.middleware.post(
        "/UpdateReasonsToCall",
        JSON.stringify({
          ...payload,
        }),
        {
          headers: { request: "UpdateReasonsToCall" },
        }
      );

      const responseData = await response.data;
      if (response.status !== 200) {
        return {
          success: responseData.success,
          message: responseData.message,
        };
      }
      return { success: responseData.success, message: responseData.message };
    },
    async SetCallOnHold(_, payload) {
      const response = await authModule.actions.middleware.post(
        "/SetCallOnHold",
        JSON.stringify({
          is_hold: payload.is_hold,
          callid: payload.callid,
          queue: payload.queue,
          caller: payload.caller,
          request_time: payload.request_time,
          unique_hold_id: payload.unique_hold_id,
        }),
        {
          headers: { request: "SetCallOnHold" },
        }
      );

      const responseData = await response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
      }
      return { success: responseData.success, message: responseData.message, result: responseData.result };
    },
    async GetCallerLastReasons(_, payload) {
      const response = await authModule.actions.middleware.get(
        "/GetCallerReasons",
        {
          params: {
            callerId: payload,
          },
          headers: { request: "GetCallerReasons" },
        }
      );

      const responseData = await response.data;
      if (response.status !== 200) {
        return {
          success: responseData.success,
          message: responseData.message,
        };
      }
      return {
        success: responseData.success,
        message: responseData.message,
        lastReasons: responseData.result.lastReasons,
      };
    },

    async GetLogos(context, payload) {
      const response = await authModule.actions.middleware.get(
        "/GetDomainLogos",
        {
          headers: { request: "logos", domain: payload },
        }
      );
      const responseData = await response.data;
      if (response.status !== 200) {
        const storedLogos = localStorage.getItem(payload + "_logos");
        if (storedLogos) {
          this.setLogos(storedLogos);
        }

        return {
          success: responseData.success,
          message: responseData.message,
        };
      }
      if (responseData.success) {
        localStorage.setItem(
          payload + "_logos",
          JSON.stringify(responseData.result.logos)
        );
        context.commit("setLogos", JSON.stringify(responseData.result.logos));
      }
      return { success: responseData.success, message: responseData.message };
    },

    ShowProgressBar(context, payload) {
      if (!payload.show) {
        payload.message = "";
      }
      context.commit("setProgressStatus", payload);
    },
    SetMessageDialog(context, payload) {
      if (!payload.show) {
        payload.message = "";
      }
      // console.log("My payload", payload);
      context.commit("SetMessageDialog", payload);
    },
    SetPhoneState(context, payload) {
      context.commit("setWebPhone", payload);
    },
    setSentiment(context, payload) {
      context.commit("setSentiment", payload);
    },
    setIsCollapsed(context, payload) {
      context.commit("setIsCollapsed", payload);
    },
    setWebRTCNeedsCheck(context, payload) {
      context.commit("setWebRTCNeedsCheck", payload);
    },
    async CheckAgentActiveCall(_, payload) {
      const response = await authModule.actions.middleware.get(
        "/CheckAgentActiveCall",
        {
          headers: {
            request: "CheckAgentActiveCall",
            domain: payload.domain,
            uname: payload.uname,
          },
        }
      );
      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
      }
      return { success: responseData.success, message: responseData.message };
    },
  },
});

export default store;
